module.exports = {
    import: "Import",
    export: "Export",
    phase: "Phase",
    quadrant: "Quadrant",
    cumulative: "Cumulative",
    average: "Average",
    voltage_profile: "Voltage profile",
    voltage: "Voltage",
    average_voltage: "Average voltage",
    current_profile: "Current profile",
    current: "Current",
    cumulative_current: "Cummulative current",
    active_power_profile: "Active power profile",
    active_power: "Active power",
    active_energy: "Active energy",
    total_energy: "Total energy",
    cumulative_active_power: "Cummulative active power",
    reactive_power_profile: "Reactive power profile",
    reactive_power: "Reactive power",
    cumulative_reactive_power: "Cummulative reactive power",
    apparent_power_profile: "Apparent power profile",
    energy_import: "Energy import",
    energy_export: "Energy export",
    energy_day: "Energy import by day",
    realtime_voltage: "Real time voltage profile",
    realtime_current: "Real time current profile",
    realtime_active_power: "Real time active power profile",
    realtime_reactive_power: "Real time reactive power profile",
    realtime_apparent_power: "Real time apparent power profile",
    realtime_energy_import_profile: "Real time energy import profile",
    realtime_energy_export_profile: "Real time energy export profile",
    appliances_energy: "Energy consumption by disaggregated appliances",
    appliances_timeline: "Appliances timeline",
    pq_map: "Appliances imprints PQ map",
    locations: "Locations",
    active_energy_last_24_hours: "Active energy last 24 hours",
    active_energy_last_14_days: "Active energy last 14 days",
    active_energy_last_12_months: "Active energy last 12 months",
    reactive_energy_last_24_hours: "Reactive energy last 24 hours",
    reactive_energy_last_14_days: "Reactive energy last 14 days",
    reactive_energy_last_12_months: "Reactive energy last 12 months",
    hourly_total_active_energy: "Hourly total active energy",
    daily_total_active_energy: "Daily total active energy",
    monthly_total_active_energy: "Monthly total active energy",
    daily_total_reactive_energy: "Daily total reactive energy",
    active_power_profile_with_appliances: "Active power profile with appliances",
    energy_consumption: "Energy consumption",
    duration: "Duration",
    runtime: "Runtime",
    viewFullscreen: "View in full screen",
    printChart: "Print chart",
    downloadPNG: "Download PNG",
    downloadJPEG: "Download JPEG",
    downloadPDF: "Download PDF",
    downloadSVG: "Download SVG",
    downloadCSV: "Download CSV",
    downloadXLS: "Download XLX",
    viewData: "View data table",
    openInCloud: "Open in Highcharts Cloud",
    resetZoom: "Reset zoom",
    loading: "Loading...",
    contextButtonTitle: "Context menu",
    scaleChange: "Change scale",
    weekdays: ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"],
    months: ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"],
    shortMonths: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"],
    monitoring_availability: "Availability per 24 hours",
    percentage_availability: "Percentage availability",
    uptime: "Uptime",
    drillUpText: "◁ Back to {series.name}",
    other: "Other",
    always_on: "Always on",
    relay: "Relay",
    disconnector_timeline: "Relay timeline",
    average_current: "Average current",
    average_active_power: "Average active power",
    active_energy_import: "Active energy import",
    active_energy_export: "Active energy export",
    frequency: "Frequency",
    quarter_hour_active_energy: "Active energy by quarter hour",
    quarter_hour_maximum_active_power: "Maximum active power in 15 minutes",
    noData: "Data not available",
    reactive_energy: "Reactive energy",
    sample: "Sample",
    year_anomaly_title: "Year model of appliance",
    month_anomaly_title: "Month model of appliance",
    week_anomaly_title: "Week model of appliance",
    day_anomaly_title: "Day model of appliance",
    duration_anomaly_title: "Duration model of appliance",
    runrun_anomaly_title: "Run-run model of appliance"
}